import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';

import {
  selectCancelPendingInvitationSucceed,
  selectCancelPendingInvitationReqError,
} from '../../../redux/circles/selectors';
import * as cancelFamilyMemberInvitation from '../../../redux/circles/cancelFamilyMemberInvitation';
import * as cancelCaregiverInvitation from '../../../redux/circles/cancelCaregiverInvitation';
import * as cancelGuardianInvitation from '../../../redux/circles/cancel-guardian-invitation-req';
import cancelPendingInvitationSaga from '../../../redux/circles/sagas/cancel-pending-invitation-saga';
import injectSaga from '../../../redux/injectSaga';

const mapDispatchToProps = {
  cancelFamilyMemberInvite: cancelFamilyMemberInvitation.actions.send,
  cancelCaregiverInvite: cancelCaregiverInvitation.actions.send,
  cancelGuardianInvite: cancelGuardianInvitation.actions.send,
  clearFamilyMemberInvite: cancelFamilyMemberInvitation.actions.clear,
  clearCaregiverInvite: cancelCaregiverInvitation.actions.clear,
  clearGuardianInvite: cancelGuardianInvitation.actions.clear,
};

const mapStateToProps = state => ({
  succeed: selectCancelPendingInvitationSucceed(state),
  rejected: selectCancelPendingInvitationReqError(state),
});

export const enhance = compose(
  injectSaga({
    key: 'pendingInvitationSaga',
    saga: cancelPendingInvitationSaga,
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(
    ({
      clearCaregiverInvite,
      clearGuardianInvite,
      clearFamilyMemberInvite,
    }) => {
      return {
        clearRequests: () => {
          clearCaregiverInvite();
          clearGuardianInvite();
          clearFamilyMemberInvite();
        },
      };
    },
  ),
);



// WEBPACK FOOTER //
// ./src/components/CircleOfCare/CancelPendingInvitationsPopup/enhance.js